/**
 * LNB 메뉴 트리 - 폴백 상수 겸 FRM_MENU 시드 원천(동결).
 * 운영 SSOT 는 DB(FRM_MENU). 여기는 서버 실패 폴백과 라우터 가드 카탈로그 판정에만 쓴다.
 */
// key = FRM_MENU.MENU_ID 와 1:1. 컨테이너 = MN_{카테고리3}[_{그룹3}] 자리수 고정(MN_HRM·MN_HRM_MBR),
// 리프 = 화면 OBJECT_ID(미확정 화면만 가칭 코드, MN_ 없이). URL path variable 로 쓰지 않는다.

export const PLAN_MENU = [
  // 인사기본 - 구성원/인사정보/신청서/조직/발령/근무/휴가
  { key: 'MN_HRM', label: '인사기본', icon: 'lnb-people', groups: [
    { key: 'MN_HRM_MBR', label: '구성원 관리', children: [
      { key: 'PHM0020', label: '구성원 초대', route: 'PHM0020' },
      { key: 'PHM0010', label: '모든 구성원', route: 'PHM0010' },
    ] },
    { key: 'MN_HRM_HRI', label: '인사정보', children: [
      { key: 'PHM0110', label: '개인인사정보', route: 'PHM0110' },
      { key: 'PHM0120', label: '전체인사정보', route: 'PHM0120' },
      { key: 'PHM0130', label: '변경내역조회', route: 'PHM0130' },
    ] },
    // 신청서(전자결재 ELA)
    { key: 'MN_HRM_APL', label: '신청서', children: [
      { key: 'ELA0010', label: '신청내역', route: 'ELA0010' },
      { key: 'ELA0020', label: '결재함', route: 'ELA0020' },
      { key: 'ELA0030', label: '기결함', route: 'ELA0030' },
      { key: 'ELA0011', label: '신청서 작성', route: 'ELA0011' },
      { key: 'ELA0012', label: '임시보관함', route: 'ELA0012' },
      { key: 'ELA0080', label: '신청서 양식 관리', route: 'ELA0080' },
    ] },
    // 전자계약 - 메뉴구조도 최종본(20260911 작업용)은 신청서와 나란한 독립 2Depth 그룹이다.
    //   계약 요청/요청 내역/구성원 별 현황/내 문서 는 ECT0010 화면 내 탭이라 메뉴 미등재.
    { key: 'MN_HRM_ECT', label: '전자계약', children: [
      { key: 'ECT0010', label: '전자계약', route: 'ECT0010' },
    ] },
    { key: 'MN_HRM_ORG', label: '조직 관리', children: [
      { key: 'ORM0002', label: '조직도', route: 'ORM0002' },
      { key: 'ORM0020', label: '조직 개편', route: 'ORM0020' },
      { key: 'ORM0030', label: '조직장 관리', route: 'ORM0030' },
      { key: 'ORM0040', label: '조직 히스토리', route: 'ORM0040' },
    ] },
    { key: 'MN_HRM_CAM', label: '발령관리', children: [
      { key: 'CAM0010', label: '발령등록', route: 'CAM0010' },
      { key: 'CAM0020', label: '발령내역', route: 'CAM0020' },
      { key: 'CAM0030', label: '입사발령', route: 'CAM0030' },
      { key: 'CAM0040', label: '입사내역', route: 'CAM0040' },
    ] },
    { key: 'MN_HRM_WRK', label: '근무 관리', children: [
      { key: 'DTS0010', label: '근태현황정보', route: 'DTS0010' },
      { key: 'DTS0020', label: '출퇴근현황관리', route: 'DTS0020' },
      { key: 'DTS0021', label: '출퇴근현황', route: 'DTS0021' },
      { key: 'DTS0030', label: '근무스케줄관리', route: 'DTS0030' },
      { key: 'DTS0031', label: '근무스케줄', route: 'DTS0031' },
      { key: 'DTS0040', label: '근로시간현황관리', route: 'DTS0040' },
      { key: 'DTS0041', label: '근로시간현황', route: 'DTS0041' },
      { key: 'DTS0050', label: '특근현황관리', route: 'DTS0050' },
      { key: 'DTS0060', label: '교대근무등록', route: 'DTS0060' },
      { key: 'DTS0061', label: '교대근무현황관리', route: 'DTS0061' },
      { key: 'DTS0062', label: '교대근무현황', route: 'DTS0062' },
      { key: 'DTS0070', label: '근무 마감', route: 'DTS0070' },
    ] },
    { key: 'MN_HRM_RST', label: '휴가 관리', children: [
      { key: 'DTS9010', label: '휴가사용현황관리', route: 'DTS9010' },
      { key: 'DTS9011', label: '휴가사용현황', route: 'DTS9011' },
      { key: 'DTS9020', label: '휴가신청내역관리', route: 'DTS9020' },
      { key: 'DTS9030', label: '연차촉진관리', route: 'DTS9030' },
      { key: 'DTS9040', label: '연차사용통보', route: 'DTS9040' },
    ] },
  ] },

  // 보상관리 - 급여 정산/급여 결과/퇴직금 관리/사회보험/연말정산
  { key: 'MN_PAY', label: '보상관리', icon: 'lnb-cases', groups: [
    { key: 'MN_PAY_STL', label: '급여 정산', children: [
      { key: 'PAY2010', label: '급여일자 관리', route: 'PAY2010' },
      { key: 'PAY2020', label: '대상자 관리', route: 'PAY2020' },
      { key: 'PAY2025', label: '급여 예외사항 관리', route: 'PAY2025' },
      { key: 'PAY2030', label: '계산기초 마감', route: 'PAY2030' },
      { key: 'PAY2040', label: '소급 관리', route: 'PAY2040' },
      { key: 'PAY2050', label: '급여 계산', route: 'PAY2050' },
      { key: 'PAY2060', label: '지급 공제 비교', route: 'PAY2060' },
    ] },
    // 급여 결과·퇴직금 관리는 미제공 - route 없는 placeholder 로만 노출한다.
    // 재노출 시 children 을 아래 주석의 원본 목록으로 되돌리면 된다(라우트·페이지는 그대로 존재).
    { key: 'MN_PAY_RSL', label: '급여 결과', children: [
      { key: 'PAY_RESULT', label: '급여 결과' },
      /* 원본: PAY3010 급여 대장 - PAY3020 급여 명세서 - PAY3030 지급 내역 조회 - PAY3040 급여 알림 발송 */
    ] },
    { key: 'MN_PAY_RTR', label: '퇴직금 관리', children: [
      { key: 'PAY_RETIRE', label: '퇴직금 관리' },
      /* 원본: PAY4010 퇴직금 대상자 관리 - PAY4020 퇴직금 계산 - PAY4030 퇴직금 지급 내역 - PAY4040 과세이연 정보 관리 - PAY4050 퇴직금 자료 - PAY4060 DC 부담금 관리 */
    ] },
    { key: 'MN_PAY_NHS', label: '사회보험', children: [
      { key: 'PAY_INSUR', label: '사회보험' },
    ] },
    { key: 'MN_PAY_YEN', label: '연말정산', children: [
      { key: 'PAY_YEAREND', label: '연말정산' },
    ] },
  ] },

  // 환경설정 - 기본설정/시스템설정/업무기준설정
  { key: 'MN_ENV', label: '환경설정', icon: 'lnb-settings', groups: [
    { key: 'MN_ENV_BSC', label: '기본 설정', children: [
      { key: 'ENV0010', label: '기본 환경 설정', route: 'ENV0010' },
      { key: 'MY0010', label: '내 설정', route: 'MY0010' },
      { key: 'HOM0020', label: '홈 위젯', route: 'HOM0020' },
    ] },
    { key: 'MN_ENV_SYS', label: '시스템 설정', children: [
      { key: 'COM0010', label: '회사 정보 관리', route: 'COM0010' },
      { key: 'SEC0010', label: '로그인 관리', route: 'SEC0010' },
      { key: 'I18N0010', label: '다국어 관리', route: 'I18N0010' },
      { key: 'HRS0010', label: '인사정보 관리', route: 'HRS0010' },
      { key: 'INV0010', label: '초대 관리', route: 'INV0010' },
      { key: 'AUTH0010', label: '권한 관리', route: 'AUTH0010' },
      { key: 'PAY0010E', label: '결제 관리', route: 'PAY0010E' },
      { key: 'LNK0010', label: '연동 관리', route: 'LNK0010' },
    ] },
    // 업무 기준 설정 = 메뉴구조도 최종본(20260911 작업용)에서 2Depth 그룹으로 쪼개졌다(96_env_biz_regroup.sql).
    //   인사 관리 / 근무기준관리 / 성과 관리 + 이미 있던 급여 관리 / 퇴직금 설정 = 5그룹.
    { key: 'MN_ENV_HRM', label: '인사 관리', children: [
      // 데이터 코드 관리 - 인사정보 1.5v S115~S122(자격/어학/포상/징계 4탭)
      { key: 'PHM0150', label: '데이터 코드 관리', route: 'PHM0150' },
      { key: 'CAM0011', label: '발령기준관리', route: 'CAM0011' },
      { key: 'CAM0012', label: '승진발령기준', route: 'CAM0012' },
      { key: 'LEV0050', label: '휴가 기준 관리', route: 'LEV0050' },
      { key: 'LEV0060', label: '연차 기준 관리', route: 'LEV0060' },
    ] },
    { key: 'MN_ENV_WRK', label: '근무기준관리', children: [
      { key: 'DTM0010', label: '근무 세부 코드', route: 'DTM0010' },
      { key: 'DTM0020', label: '근무 그룹 생성', route: 'DTM0020' },
      { key: 'DTM0030', label: '교대 근무 기준 관리', route: 'DTM0030' },
      { key: 'DTM0040', label: '출퇴근 체크 방식 설정', route: 'DTM0040' },
      { key: 'DTM0060', label: '회사 휴일 관리', route: 'DTM0060' },
    ] },
    // 성과 관리 - 기획 전. placeholder 리프를 둬야 그룹이 렌더된다(사회보험·연말정산과 같은 방식).
    { key: 'MN_ENV_PRF', label: '성과 관리', children: [
      { key: 'ENV_BIZ_PERF', label: '성과 관리' },
    ] },
    // 결재선·대결은 메뉴구조도에 귀속 그룹이 없어(문자열 0건) 잔류 그룹에 보관한다. 기획 확정 시 이동.
    { key: 'MN_ENV_BIZ', label: '업무 기준 설정', children: [
      { key: 'ELA9000', label: '결재선 관리', route: 'ELA9000' },
      { key: 'ELA0040', label: '대결 관리', route: 'ELA0040' },
    ] },
    // 급여 환경설정 (환경설정 > 급여 관리)
    { key: 'MN_ENV_PAY', label: '급여 관리', children: [
      { key: 'PAY1010', label: '급여 항목 설정', route: 'PAY1010' },
      { key: 'PAY1020', label: '급여 유형 설정', route: 'PAY1020' },
      { key: 'PAY1030', label: '계약 금액 테이블 기준', route: 'PAY1030' },
      // 구조도 순서 = 계약 금액 -> 구성원 급여 테이블 -> 비과세 (96_env_biz_regroup.sql)
      { key: 'PAY1050', label: '구성원 급여 테이블 관리', route: 'PAY1050' },
      { key: 'PAY1040', label: '비과세 및 감면 대상자', route: 'PAY1040' },
      { key: 'PAY1060', label: '유급 휴가 지급 관리', route: 'PAY1060' },
      { key: 'PAY1070', label: '간이 세액 조견표', route: 'PAY1070' },
      { key: 'PAY1080', label: '급여 결과 설정', route: 'PAY1080' },
    ] },
    // 퇴직금 환경설정 - 미제공 placeholder 로만 노출한다.
    // 재노출 시 children 을 아래 주석의 원본 목록으로 되돌리면 된다.
    { key: 'MN_ENV_RTR', label: '퇴직금 설정', children: [
      { key: 'ENV_RETIRE', label: '퇴직금 설정' },
      /* 원본: PAY1110 퇴직금 관리 정보 - PAY1120 퇴직금 계산 설정 */
    ] },
  ] },

  // 개발자 - 편의기능(관리자 전용). 리프는 업무기능에 매핑하지 않는다(GROUP_FUNC 제외)
  // -> FRM_AUTH_FUNC_MENU_MAP 미매핑 = deny-by-default 로 일반 권한엔 숨김, 관리자만 short-circuit 노출.
  { key: 'MN_DEV', label: '개발자', icon: 'lnb-bento', groups: [
    { key: 'MN_DEV_TLS', label: '개발자 도구', children: [
      // 개발자 편의 도구 - 개발자가 메뉴 최초 생성·기능 매핑. 추후 이동 가능성 있음
      { key: 'MNU0010', label: '메뉴 관리', route: 'MNU0010' },
      { key: 'AUTH0020', label: '권한·메뉴 점검', route: 'AUTH0020' },
      { key: 'DEV0020', label: '코드 관리', route: 'DEV0020' },
      { key: 'DEV0030', label: '표준화면 빌더', route: 'DEV0030' },
      { key: 'DEV0050', label: '출퇴근 시뮬레이터', route: 'DEV0050' },
      { key: 'DEV0090', label: '고객사 온보딩', route: 'DEV0090' },
    ] },
  ] },
];

/** 라우트가 들어 있는 대메뉴(1depth) 키. 메뉴에 없는 화면(홈 등)이면 ''. 새로고침·주소 입력·알림 링크 진입 때 왼쪽 메뉴를 맞춘다(D-244). */
export function findCategoryKey(tree, routeName) {
  if (!routeName || !Array.isArray(tree)) return '';
  const cat = tree.find((c) => (c.groups || []).some((g) => (g.children || []).some((ch) => ch.route === routeName)));
  return cat ? cat.key : '';
}

/**
 * 메뉴 트리(raw) -> InLNBSubmenu items shape. expanded 는 2depth 그룹 펼침 맵이다.
 * activeRoute 와 일치하는 3depth 에 active 를 주고 그 그룹은 기본 펼침(사용자가 접으면 expanded 가 이김).
 */
export function buildPlanItems(expanded = {}, tree = PLAN_MENU, activeRoute = '') {
  return tree.map((cat) => ({
    key: cat.key,
    label: cat.label,
    icon: cat.icon,
    submenu: cat.groups.map((g) => {
      const hasActive = !!activeRoute && g.children.some((c) => c.route === activeRoute);
      return {
        key: g.key,
        label: g.label,
        expanded: g.key in expanded ? !!expanded[g.key] : hasActive,
        children: g.children.map((c) => ({ key: c.key, label: c.label, route: c.route, active: c.route === activeRoute })),
      };
    }),
  }));
}
